import { render, staticRenderFns } from "./OperaNoticesWindow.vue?vue&type=template&id=0916d344&"
import script from "./OperaNoticesWindow.vue?vue&type=script&lang=js&"
export * from "./OperaNoticesWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports